













import { Component, Vue, Provide } from 'vue-property-decorator';
import HelloWorld from './components/HelloWorld.vue';
import Header from './components/Header.vue';
import Navbar from './components/Navbar.vue';
import StudyExp from './components/StudyExp.vue';
import ProjectTiles from './components/ProjectTiles.vue';
import Projects from './components/Projects.vue';
import Language from './components/Language.vue';
import Main from './components/Main.vue';
import Footer from './components/Footer.vue';
import Contact from './components/Contact.vue';
import 'buefy/lib/buefy.css';
import resume from './resume_en.json';

@Component({
  components: {
    HelloWorld,
    Header,
    Navbar,
    Main,
    StudyExp,
    ProjectTiles,
    Language,
    Projects,
    Footer,
    Contact,
  },
})
export default class App extends Vue {
  @Provide() public resume = resume;
}
